import React, { type ComponentPropsWithoutRef } from 'react';
import Watchers from './main.tsx';

const WatchersWithCanManageWatchersCheck = (props: ComponentPropsWithoutRef<typeof Watchers>) => {
	if (!props.configs?.canManageWatchers) {
		return null;
	}
	return <Watchers {...props} />;
};

export default WatchersWithCanManageWatchersCheck;
